import { useCallback, useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import "@/Feature.css";
import "@/Game.css";
import "@/Admin.css";
import "@/WinGo.css";
import { api } from "./lib/api";
import { SiteProvider } from "./lib/site";
import Auth from "./pages/user/Auth";
import Home from "./pages/user/Home";
import Account from "./pages/user/Account";
import Transactions from "./pages/user/Transactions";
import GameHistory from "./pages/user/GameHistory";
import Notifications from "./pages/user/Notifications";
import Deposit from "./pages/user/Deposit";
import Withdraw from "./pages/user/Withdraw";
import WinGo from "./pages/user/WinGo";
import AdminApp from "./pages/admin/AdminApp";

const PAGES = { home: Home, account: Account, history: Transactions, gamehistory: GameHistory, notifications: Notifications, deposit: Deposit, withdraw: Withdraw, wingo: WinGo };

function AppInner() {
  const [user, setUser] = useState(null), [data, setData] = useState(null), [page, setPage] = useState("home"), [checking, setChecking] = useState(true);
  const load = useCallback(async () => {
    try {
      const me = await api.get("/auth/me");
      setUser(me.data);
      if (me.data.role !== "admin") setData((await api.get("/user/home")).data);
    } catch { setUser(null); }
    setChecking(false);
  }, []);
  useEffect(() => { load(); }, [load]);
  const logout = async () => { await api.post("/auth/logout").catch(() => {}); localStorage.removeItem("blueplay_token"); setUser(null); setData(null); setPage("home"); };
  if (checking) return <div className="loading">Loading Laxmiwin…</div>;
  if (!user) return <Auth onLogin={() => { setChecking(true); load(); }} />;
  if (user.role === "admin") return <AdminApp admin={user} onLogout={logout} />;
  if (!data) return <div className="loading">Loading Laxmiwin…</div>;
  const Page = PAGES[page] || Home;
  return <Page data={data} setPage={setPage} onRefresh={load} onDone={load} onLogout={logout} />;
}

export default function App() {
  return <BrowserRouter><SiteProvider><AppInner /><Toaster position="top-center" theme="dark" richColors /></SiteProvider></BrowserRouter>;
}
